import I18n from '~/src/common/services/I18n';
import { ImageParams } from '~/src/common/typings/image';
import { getImageUrl } from '~/src/common/utils/cloudinary';

import * as S from './layout';

type Props = {
  title: string;
  text?: string;
  icon?: string;
  link?: string;
  onClick?: () => void;
};

const Reinsurance = ({ title, text, icon, link, onClick }: Props) => (
  <S.Container>
    {icon ? <S.Icon src={getImageUrl(icon, ImageParams.familyIcon)} alt={title} /> : null}
    <S.Text>
      <strong>{title} </strong>
      {text ? <span>{text}</span> : null}
    </S.Text>
    {link && (
      <S.Action href={link} onClick={onClick}>
        {I18n.t('common.discover')}
      </S.Action>
    )}
  </S.Container>
);

export default Reinsurance;
